import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAdminApi } from '../admin/api'

const UUID = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi
const MAX_POR_CARGA = 20

// Petición del club (2026-10-31): "no sé si hay fallos, tengo 0 visibilidad". Envía al API los errores
// de JavaScript que ve cada persona (Backoffice › Uso y estado), con la pantalla en la que estaba. Como
// mucho uno por mensaje y 20 por pantalla visitada, para no inundar si algo falla en bucle.
export function ReporteErrores() {
  const api = useAdminApi()
  const location = useLocation()
  const pantalla = location.pathname.replace(UUID, ':id')

  useEffect(() => {
    const enviados = new Set<string>()
    function enviar(mensaje: string) {
      if (!mensaje || enviados.has(mensaje) || enviados.size >= MAX_POR_CARGA) return
      enviados.add(mensaje)
      api.post('/uso/error', { mensaje, pantalla }).catch(() => {})
    }
    const onError = (e: ErrorEvent) => enviar(e.error?.stack?.split('\n').slice(0, 3).join(' ') || e.message)
    const onRejection = (e: PromiseRejectionEvent) =>
      enviar(e.reason instanceof Error ? `${e.reason.name}: ${e.reason.message}` : String(e.reason))
    window.addEventListener('error', onError)
    window.addEventListener('unhandledrejection', onRejection)
    return () => {
      window.removeEventListener('error', onError)
      window.removeEventListener('unhandledrejection', onRejection)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pantalla])

  return null
}
